import coreStore from './core-store';
import {parsePageResponse} from '../utils/utils'
import Vue from 'vue'
import Axios from 'axios'

export default () => {

    const accountResource = 'account/api/v1/accounts';
    const bankResource = 'account/api/v1/banks';

    const store = coreStore.queryStore(coreStore.createCoreStore('account', accountResource));

    store.state.accountBalances = {}

    store.mutations.addAccount = function (state, {account}) {
        state.accounts.push(account);
    };


    store.state.banks = {}
    store.mutations.addBank = function (state, {bank}) {
        state.banks[bank.id] = bank;
    }
    store.getters.bank = (state) => (id) => state.banks[id]

    store.actions.refreshBanks = function ({commit, state}) {
        return Axios.get(bankResource)
            .then(res => {
                res.data.forEach(bank => commit("addBank", {bank}))
            })
    }

    store.actions.refreshAllBalances = function ({commit, state}) {
        commit("cleanBalances");
        return Promise.all(state.accounts
            .filter(account => account.internal)
            .map(account => {
                return Axios.get(`account/api/v1/accounts/${account.id}/account-balances?size=20000`)
                    .then(res => commit("addBalancesToStore", {account: account, balances: res.data}));
            }))
    };

    store.mutations.cleanBalances = function (state) {
        Vue.set(state, "accountBalances", {})
    }

    store.mutations.addBalancesToStore = function (state, {account, balances}) {
        Vue.set(state.accountBalances, account.id, [...balances].sort((a, b) => new Date(b.balanceDate) - new Date(a.balanceDate)));
    }

    store.actions.saveAccountBalance = function ({dispatch, state}, {account: {id}, accountBalance}) {
        return Axios.post(`account/api/v1/accounts/${id}/account-balances`, accountBalance)
            .then(res => {
                if (accountBalance.id == undefined) {
                    accountBalance.id = res.data;
                }
                let oldIdx = state.accountBalances[id].findIndex(bal => bal.id == accountBalance.id);
                if (oldIdx == -1) {
                    state.accountBalances[id].push(accountBalance);
                } else {
                    Vue.set(state.accountBalances[id], oldIdx, accountBalance);
                }
            })
    }

    store.state.accountBalanceItems = {};

    store.mutations.addItemsToBalance = function (state, {accountBalance, items}) {
        Vue.set(state.accountBalanceItems, accountBalance.accountBalanceId, {
            content: items.list,
            page: items.meta.page,
            pageSize: items.meta.pageSize,
            count: items.meta.count
        });
    }

    store.getters.accountBalanceItems = (state) => (accountBalance) => {
        return state.accountBalanceItems[accountBalance.accountBalanceId];
    }

    store.getters.accountBalances = (state) => (account) => {
        return state.accountBalances[account.id];
    }

    store.getters.accountsByInternal = (state) => (internal) => {
        return state.accounts.filter(acc => internal || acc.internal == internal);
    }

    store.getters.accountBalanceItemsPagination = (state) => (accountBalance) => ({
        pages: Math.ceil(state.accountBalanceItems[accountBalance.accountBalanceId].count / state.accountBalanceItems[accountBalance.accountBalanceId].pageSize),
        actualPage: state.accountBalanceItems[accountBalance.accountBalanceId].page,
        pageSize: state.accountBalanceItems[accountBalance.accountBalanceId].pageSize,
        actualItems: state.accountBalanceItems[accountBalance.accountBalanceId].content.length,
        totalItems: state.accountBalanceItems[accountBalance.accountBalanceId].count
    })

    store.actions.fetchAccountBalanceTimelines = function ({commit, state}, {dateFrom, dateTo, accountIds}) {
        let targetUrl = `account/api/v1/account-balance-timelines?dateFrom=${dateFrom}&dateTo=${dateTo}`
        if (accountIds != undefined) {
            targetUrl += "accountIds=" + accountIds.join(",")
        }
        return Axios.get(targetUrl)
            .then(res => res.data);
    }

    store.actions.refreshBalanceItems = function ({commit, state}, {balance, page, query}) {
        let targetUrl = `account/api/v1/accounts/${balance.accountId}/account-balances/${balance.accountBalanceId}/items?page=${page}`;
        if (typeof query != 'undefined' && query != null) targetUrl += `&query=${encodeURI(JSON.stringify(query))}`
        return Axios.get(targetUrl)
            .then(parsePageResponse)
            .then(res => commit('addItemsToBalance', {accountBalance: balance, items: res}));

    };

    return store;
}



// export default {
//     namespaced: true,
//     state: {
//         accounts: [],
//     },
//     getters: {
//         accounts: (state) => {
//             return state.accounts;
//         },
//         account: (state) => (id) => {
//             let acc = state.accounts.filter(acc => acc.id == id);
//             return acc.length != 0 ? acc[0] : null;
//         }
//     },
//     mutations: {
//         addAccount(state, {account}) {
//             state.accounts.push({... account, balances: []});
//         },
//         addBalancesToAccount(state, {account, balances}) {
//             state.accounts.filter(acc => acc.id === account.id)[0].balances = balances;
//         },
//         clearAccounts(state) {
//             state.accounts = [];
//         }
//     },
//     actions: {
//         refreshAccounts({commit}) {
//             commit('clearAccounts');
//             return fetch("account/api/v1/accounts")
//                 .then(res => res.json())
//                 .then(res => {
//                     res.forEach(acc => commit("addAccount", { account: acc }));
//                 })
//         },
//         refreshAllBalances({commit, state}) {
//             return state.accounts.map(account => {
//                 return fetch(`account/api/v1/accounts/${account.id}/account-balances`)
//                     .then(res => res.json())
//                     .then(res =>  commit("addBalancesToAccount", { account: account, balances: res }));
//             })
//         },
//         saveAccount({commit, dispatch}, payload) {
//             return fetch(`account/api/v1/accounts`, {
//                 body: JSON.stringify(payload),
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 method: "POST"
//             })
//                 .then(() => dispatch('refreshAccounts'));
//         },
//         deleteAccount({commit, dispatch}, payload) {
//             return fetch(`account/api/v1/accounts/${payload.id}`, {
//                 method: "DELETE"
//             })
//                 .then(() => dispatch('refreshAccounts'));
//         }
//     }
// }
